import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing, theme} from '@yandex-delivery/blocks/theme/theme'

// Цвет текста на акцентной (жёлтой) кнопке. Blocks Text по умолчанию серый,
// а LinkButton-<a> не ловит глобальный dark-override для action-кнопок, поэтому
// форсим on-control цвет (#21201F) в обеих темах — фон всегда controlMain.
const ON_CONTROL_COLOR = '#21201F'

export const classes = {
  root: css`
    padding: ${spacing(1)};
  `,
  plate: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 56px;
    padding: ${spacing(1, 2)};
    border-radius: ${theme.spacing(1.5)}px;
    text-align: center;
  `,
  title: css`
    font-weight: 500 !important;
  `,
  subtitle: css`
    margin-top: 1px;
  `,
  // Текст кнопки: один центрированный ряд «Оплатить · 199 ₽», чуть жирнее.
  label: css`
    text-align: center;

    &,
    & * {
      color: ${ON_CONTROL_COLOR} !important;
      font-weight: 600 !important;
    }
  `,
}
